{
  "show_site_header": false,

  "hero_image": "assets/img/2026-gstp_hero.webp",
  "title": "Welcome to the Global System of Trade Preferences",
  "title_highlight": "Global System of Trade Preferences",
  "subtitle": "A trade agreement designed by and for developing countries.",

  "stats": [
    { "prefix": "", "value": 4, "decimals": 0, "suffix": " billion+", "label": "People" },
    { "prefix": "$", "value": 18, "decimals": 0, "suffix": " trillion", "label": "Market size" },
    { "prefix": "", "value": 18, "decimals": 0, "suffix": "%", "label": "Of global merchandise imports" },
    { "text_lines": ["Expanding market access,", "diversifying trade, strengthening"], "highlight": "resilience" }
  ],

  "nav": [{ "label": "News", "href": ".news-section" }, { "label": "Publications", "href": ".publications-section" }, { "label": "Videos", "href": ".videos-section" }],

  "ni_eyebrow_concepts": "Concepts & context",
  "ni_eyebrow_bigpicture": "The big picture",
  "ni_link1_text": "GSTP Agreement (1988)",
  "ni_link1_href": "https://unctad.org/system/files/official-document/ditcmisc57_en.pdf",
  "ni_link2_text": "São Paulo Round Protocol of the GSTP (2010)",
  "ni_link2_href": "https://unctad.org/system/files/official-document/gstp-sprncfozd3_en.pdf",

  "ni_title": "Why it matters?",
  "ni_description": "As global trade grows more fragmented and protectionist, the GSTP gives developing countries a preferential channel to diversify export markets and build economic resilience. GSTP economies represent a combined $18 trillion market, accounting for 18% of global merchandise imports.",
  "ni_description2": "The agreement is also nearing a major milestone: the São Paulo Round, offering deeper tariff cuts across thousands of products, is just one ratification away from entering into force — a step that could unlock up to $14 billion in welfare gains for participating economies.",

  "ni_def_title": "What is the GSTP?",
  "ni_def_statement_prefix": "The Global System of Trade Preferences (GSTP) could unlock preferential tariff treatment among",
  "ni_def_badge": "43",
  "ni_def_statement_suffix": "participating developing countries, reducing tariffs on thousands of traded products.",
  "ni_def_description": "The GSTP is the only inter-regional trade agreement created exclusively by and for developing countries. Established in 1988, it expands South–South trade through preferential market access. The Committee of Participants is the GSTP's governing body, with UNCTAD serving as its Secretariat.",
  "ni_def_attribution": "UNCTAD, Global System of Trade Preferences among Developing Countries.",

  "tl_eyebrow": "Timeline",
  "tl_title": "Historic milestone",
  "tl_description": "For more than three decades, the GSTP has provided a framework for expanding trade among developing countries. Today, the Agreement is approaching an important milestone with the entry into force of the São Paulo Round – one additional ratification is required.",
  "tl_milestones": [{ "year": "1988", "label": "GSTP Agreement adopted" }, { "year": "1989", "label": "Agreement enters into force" }, { "year": "2010", "label": "São Paulo Round concluded" }, { "year": "Today", "label": "One ratification away from entry into force", "current": true }],

  "tr_eyebrow": "Key figures",
  "tr_groups": [
    {
      "title": "Economic welfare",
      "description": "The São Paulo Round could unlock substantial economic gains for developing countries — cutting tariffs across thousands of traded products and expanding preferential market access.",
      "tiles": [
        { "prefix": "", "value": 14, "decimals": 0, "suffix": " billion", "label": "Potential welfare gains", "description": "Under the São Paulo Round." },
        { "prefix": "", "value": 20, "decimals": 0, "suffix": "%", "label": "Tariff reduction", "description": "São Paulo Round Protocol" },
        { "prefix": "", "value": 47000, "decimals": 0, "suffix": "", "label": "Products covered", "description": "Traded products subject to preferential tariff cuts under the São Paulo Round." }
      ]
    },
    {
      "title": "Global resilience",
      "description": "As the global economy becomes more uncertain, expanding South–South trade offers new opportunities to diversify export markets, strengthen resilience and foster sustainable economic growth.",
      "tiles": []
    }
  ],

  "mb_eyebrow": "Membership",
  "mb_title": "Participating countries",
  "mb_mercosur_prefix": "MERCOSUR: for GSTP purposes:",
  "mb_mercosur_members": "Argentina, Brazil, Paraguay and Uruguay",
  "mb_chip_label": "+ MERCOSUR",

  "tc_title": "Intra-GSTP trade accounts for almost one quarter of the participating countries' exports",
  "tc_subtitle": "Share of exports to countries participating in the Global System of Trade Preferences, percentage, 2025",
  "tc_legend": [{ "category": "ratifying", "label": "GSTP São Paulo Round Protocol ratifying party" }, { "category": "signatory", "label": "Other GSTP São Paulo Round Protocol signatory" }, { "category": "participant", "label": "Other GSTP participant" }],
  "tc_data": [
    { "name": "Benin", "code": "bj", "value": 52.95, "category": "participant" },
    { "name": "Iran (Islamic Republic of)", "code": "ir", "value": 46.0, "category": "participant" },
    { "name": "Bolivia (Plurinational State of)", "code": "bo", "value": 40.2, "category": "participant" },
    { "name": "Malaysia", "code": "my", "value": 39.01, "category": "ratifying" },
    { "name": "Indonesia", "code": "id", "value": 37.18, "category": "signatory" },
    { "name": "Iraq", "code": "iq", "value": 36.99, "category": "participant" },
    { "name": "Venezuela (Bolivarian Rep. of)", "code": "ve", "value": 35.2, "category": "participant" },
    { "name": "Mozambique", "code": "mz", "value": 34.51, "category": "participant" },
    { "name": "Singapore", "code": "sg", "value": 34.36, "category": "participant" },
    { "name": "Argentina", "code": "ar", "value": 32.75, "category": "signatory" },
    { "name": "Myanmar", "code": "mm", "value": 32.13, "category": "participant" },
    { "name": "United Republic of Tanzania", "code": "tz", "value": 28.97, "category": "participant" },
    { "name": "Nigeria", "code": "ng", "value": 26.99, "category": "participant" },
    { "name": "Republic of Korea", "code": "kr", "value": 24.52, "category": "signatory" },
    { "name": "MERCOSUR", "value": 24.13, "category": "signatory" },
    { "name": "Thailand", "code": "th", "value": 23.6, "category": "participant" },
    { "name": "Brazil", "code": "br", "value": 22.5, "category": "signatory" },
    { "name": "Guinea", "code": "gn", "value": 22.32, "category": "participant" },
    { "name": "Trinidad and Tobago", "code": "tt", "value": 22.32, "category": "participant" },
    { "name": "Chile", "code": "cl", "value": 21.17, "category": "participant" },
    { "name": "Paraguay", "code": "py", "value": 19.58, "category": "signatory" },
    { "name": "Peru", "code": "pe", "value": 19.51, "category": "participant" },
    { "name": "Egypt", "code": "eg", "value": 19.36, "category": "signatory" },
    { "name": "Sri Lanka", "code": "lk", "value": 18.91, "category": "participant" },
    { "name": "Philippines", "code": "ph", "value": 18.59, "category": "participant" },
    { "name": "India", "code": "in", "value": 18.48, "category": "ratifying" },
    { "name": "Cameroon", "code": "cm", "value": 17.31, "category": "participant" },
    { "name": "Morocco", "code": "ma", "value": 15.32, "category": "signatory" },
    { "name": "Dem. People's Rep. of Korea", "code": "kp", "value": 14.66, "category": "participant" },
    { "name": "Nicaragua", "code": "ni", "value": 14.34, "category": "participant" },
    { "name": "Sudan", "code": "sd", "value": 13.47, "category": "participant" },
    { "name": "Pakistan", "code": "pk", "value": 12.62, "category": "participant" },
    { "name": "Ghana", "code": "gh", "value": 12.4, "category": "participant" },
    { "name": "Uruguay", "code": "uy", "value": 12.38, "category": "signatory" },
    { "name": "Cuba", "code": "cu", "value": 12.17, "category": "ratifying" },
    { "name": "Viet Nam", "code": "vn", "value": 12.0, "category": "participant" },
    { "name": "Ecuador", "code": "ec", "value": 11.91, "category": "participant" },
    { "name": "Algeria", "code": "dz", "value": 11.76, "category": "participant" },
    { "name": "Guyana", "code": "gy", "value": 11.25, "category": "participant" },
    { "name": "Tunisia", "code": "tn", "value": 11.15, "category": "participant" },
    { "name": "Bangladesh", "code": "bd", "value": 7.69, "category": "participant" },
    { "name": "Zimbabwe", "code": "zw", "value": 5.53, "category": "participant" },
    { "name": "Libya", "code": "ly", "value": 5.33, "category": "participant" },
    { "name": "Mexico", "code": "mx", "value": 3.24, "category": "participant" }
  ],
  "tc_source_label": "Source:",
  "tc_source": "UN Trade and Development (UNCTAD) based on UNCTADstat.",
  "tc_note_label": "Note:",
  "tc_note": "Intra-MERCOSUR trade is not counted in intra-GSTP trade. The value for MERCOSUR reflects the extra-MERCOSUR exports of its members (Argentina, Brazil, Paraguay, and Uruguay).",
  "tc_link1_text": "GSTP Database (UNCTADstat Data Centre)",
  "tc_link1_href": "https://unctadstat.unctad.org/datacentre/dataviewer/US.GSTP_TradeMatrix",
  "tc_link2_text": "See more data insights",
  "tc_link2_href": "https://unctadstat.unctad.org/insights/theme/320"
}
